import type { CommonContextStore } from 'src/types/context'

export default function getLoginLinks(context: CommonContextStore['context']) {
  const next = encodeURIComponent(window.location.href)

  return {
    get medtochka() {
      const clientId = context.is_main_site_pd ? 'prodoctorov' : `ydoc_${context.request.country.iso.toLowerCase()}`

      return `${context.site_mt}/services/sso/login/?preselected_country=${context.request.country.iso}&client_id=${clientId}&next=${next}`
    },
    get profileYdoc() {
      return `https://${window.location.hostname}/profile/login/?next=${next}`
    },
    get profile() {
      return `https://${context.site_sso_auth.domain}/profile/login/?next=${next}`
    },
  }
}
